module.exports = __webpack_public_path__ + "static/EnmTX_BosMiguel_L_A_cl-673e74869ac08d47446d54bdd5a7b8df.gif";